var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbar__logo" }, [
    _vm.h1
      ? _c("h1", [
          _c(
            "a",
            { staticClass: "navbar__logo__image", attrs: { href: "/" } },
            [
              _c("img", {
                attrs: {
                  src: _vm.image,
                  srcset: _vm.imageSource,
                  alt: _vm.alt,
                },
              }),
              _c("span", { staticClass: "u-hidden" }, [
                _vm._v(_vm._s(_vm.alt)),
              ]),
            ]
          ),
        ])
      : _c("div", [
          _c(
            "a",
            { staticClass: "navbar__logo__image", attrs: { href: "/" } },
            [
              _c("img", {
                attrs: {
                  src: _vm.image,
                  srcset: _vm.imageSource,
                  alt: _vm.alt,
                },
              }),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }